import widgetIsPresent from '../../utils/widgetIsPresent';
import getElementAttributes from '../../utils/getElementAttributes';

export const DDC_LINK_VEHICLECOMPARECHECK = 'ddc.link.vehicleCompareCheck';

/**
 * jQuery Event Object
 * @external Event
 * @see {@link https://api.jquery.com/category/events/event-object/} *
 * @param {Window} win The Window object in the browser.
 * @param {external:Event} event jQuery Event Object
 * @returns
 */
function vehicleCompare(
	{
		DDC: {
			dataLayer: {
				page: {
					pageInfo: { pageWidgets }
				}
			}
		}
	},
	{ target: element }
) {
	let eventObject;
	if (!widgetIsPresent(/ws-inv-listing/, pageWidgets)) {
		const checked = !!element.checked;
		const eventData = {
			checked,
			element
		};

		const container = element.closest('.inventoryList .item');
		const hproduct =
			container &&
			container.querySelector('.hproduct, .vehicle-card[data-uuid]');

		if (hproduct) {
			const attributes = getElementAttributes(hproduct);
			({
				'data-vin': eventData.vin = '',
				'data-make': eventData.make = '',
				'data-model': eventData.model = '',
				'data-year': eventData.year = '',
				'data-bodystyle': eventData.bodyStyle = '',
				'data-trim': eventData.trim = '',
				'data-exteriorcolor': eventData.exteriorColor = '',
				'data-index-position': eventData.position = '',
				'data-type': eventData.type = ''
			} = attributes);

			try {
				eventData.internetPrice = atob(
					attributes['data-internetprice']
				);
				eventData.msrp = atob(attributes['data-msrp']);
			} catch (error) {
				eventData.internetPrice = '';
				eventData.msrp = '';
			}
		}

		eventObject = {
			eventType: DDC_LINK_VEHICLECOMPARECHECK,
			eventData
		};
	}

	return eventObject;
}

export default vehicleCompare;
